"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearFormattingExtension = void 0;
const core_1 = require("@remirror/core");
const getNodeNamesByGroup_1 = require("../../utils/getNodeNamesByGroup");
const getMarkNamesByGroup_1 = require("../../utils/getMarkNamesByGroup");
let ClearFormattingExtension = class ClearFormattingExtension extends core_1.PlainExtension {
    get name() {
        return 'clearFormatting';
    }
    clearFormatting() {
        return ({ dispatch, tr, state }) => {
            const { empty, ranges } = state.selection;
            const schema = state.schema;
            const formattingNodes = (0, getNodeNamesByGroup_1.getNodeNamesByGroup)(schema, core_1.ExtensionTag.FormattingNode);
            const formattingMarks = (0, getMarkNamesByGroup_1.getMarkNamesByGroup)(schema, core_1.ExtensionTag.FormattingMark);
            let isChanged = false;
            ranges.forEach(({ $from, $to }) => {
                // Check if there is a selection or not, if no selection use the doc content size as the range
                state.doc.nodesBetween(empty ? 0 : $from.pos, empty ? state.doc.content.size : $to.pos, (node, pos) => {
                    // Clear marks (bold, italic, etc)
                    node.marks.forEach((mark) => {
                        if (formattingMarks.includes(mark.type.name)) {
                            tr.removeMark(pos, pos + node.nodeSize, mark);
                            isChanged = true;
                        }
                    });
                    // Leave non-foramtting nodes as-is
                    if (!formattingNodes.includes(node.type.name)) {
                        return;
                    }
                    // Clear node attributes & set to paragraph by default
                    if (node.type.name === schema.nodes.paragraph.name) {
                        const { nodeTextAlignment } = node.attrs;
                        if (nodeTextAlignment && nodeTextAlignment !== 'left') {
                            tr.setNodeAttribute(pos, 'nodeTextAlignment', null);
                            isChanged = true;
                        }
                    }
                    else {
                        tr.setNodeMarkup(pos, schema.nodes.paragraph, null, node.marks);
                        isChanged = true;
                    }
                });
            });
            dispatch?.(tr);
            return isChanged;
        };
    }
};
__decorate([
    (0, core_1.command)()
], ClearFormattingExtension.prototype, "clearFormatting", null);
ClearFormattingExtension = __decorate([
    (0, core_1.extension)({})
], ClearFormattingExtension);
exports.ClearFormattingExtension = ClearFormattingExtension;
